import {
  FaTachometerAlt,
  FaBoxes,
  FaPalette,
  FaCubes,
  FaTruck,
  FaUsers,
  FaWarehouse,
  FaIndustry,
  FaFileInvoice,
  FaChartBar,
  FaCog
} from "react-icons/fa";

import {
  NavLink
} from "react-router-dom";

import "./Sidebar.css";

const Sidebar = () => {

  return (

    <aside className="sidebar">

      {/* Logo */}

      <div className="sidebar-logo">

        <div className="logo-box">

          PS

        </div>

        <div>

          <h5>PaperStock</h5>

          <span>ERP System</span>

        </div>

      </div>

      {/* User */}

      <div className="sidebar-user">

        <div className="avatar">

          AD

        </div>

        <div>

          <h6>Administrator</h6>

          <small>System Admin</small>

        </div>

      </div>

      {/* Navigation */}

      <div className="sidebar-section">

        <p className="menu-title">
          MAIN
        </p>

        <NavLink
          to="/dashboard"
          className="menu-link"
        >
          <FaTachometerAlt />
          <span>Dashboard</span>
        </NavLink>

      </div>

      <div className="sidebar-section">

        <p className="menu-title">
          MASTERS
        </p>

        <NavLink
          to="/materials"
          className="menu-link"
        >
          <FaBoxes />
          <span>Materials</span>
        </NavLink>

        <NavLink
          to="/designs"
          className="menu-link"
        >
          <FaPalette />
          <span>Designs</span>
        </NavLink>

        <NavLink
          to="/products"
          className="menu-link"
        >
          <FaCubes />
          <span>Products</span>
        </NavLink>

        <NavLink
          to="/suppliers"
          className="menu-link"
        >
          <FaTruck />
          <span>Suppliers</span>
        </NavLink>

        <NavLink
          to="/customers"
          className="menu-link"
        >
          <FaUsers />
          <span>Customers</span>
        </NavLink>

      </div>

      <div className="sidebar-section">

        <p className="menu-title">
          OPERATIONS
        </p>

        <NavLink
          to="/inventory"
          className="menu-link"
        >
          <FaWarehouse />
          <span>Inventory</span>
        </NavLink>
        <NavLink
  to="/grn"
  className="menu-link"
>
  Add Invard Stock
</NavLink>

<NavLink
  to="/stock-adjustment"
  className="menu-link"
>
  Stock Adjustment
</NavLink>

<NavLink
  to="/grn-list"
  className="menu-link"
>
  GRN History
</NavLink>

<NavLink
  to="/sales-orders"
  className="menu-link"
>
  Sales Order
</NavLink>

<NavLink
  to="/sales-order-list"
  className="menu-link"
>
  Sales Orders List
</NavLink>

        <NavLink
          to="/production"
          className="menu-link"
        >
          <FaIndustry />
          <span>Production</span>
        </NavLink>

        <NavLink
  to="/fg-stock"
  className="menu-link"
>
  <FaBoxes />
  <span>
    Finished Goods Stock
  </span>
</NavLink>

        <NavLink
          to="/dispatch"
          className="menu-link"
        >
          <FaFileInvoice />
          <span>Dispatch</span>
        </NavLink>

      </div>

      <div className="sidebar-section">

        <p className="menu-title">
          REPORTS
        </p>

        <NavLink
  to="/stock-ledger"
  className="menu-link"
>
  Stock Ledger
</NavLink>

        <NavLink
          to="/reports"
          className="menu-link"
        >
          <FaChartBar />
          <span>Reports</span>
        </NavLink>

      </div>

      <div className="sidebar-footer">

        <NavLink
          to="#"
          className="menu-link"
        >
          <FaCog />
          <span>Settings</span>
        </NavLink>

      </div>

    </aside>

  );

};

export default Sidebar;